import FilterItem from '../FilterItem';

class FilterCheckbox extends FilterItem {
  constructor(conf, subcategory) {
    super(conf, subcategory);
  }

  getDefaultBooleanValue() {
    const { defaultValue } = this.options || {};
    if (typeof defaultValue === 'function') {
      return Boolean(defaultValue());
    }
    if (defaultValue === undefined || defaultValue === null) {
      return false;
    }
    return Boolean(defaultValue);
  }

  async apply(values) {
    if (!values || values.length === 0) {
      this.value = this.getDefaultBooleanValue();
      return;
    }
    const val = values[0];
    if (typeof val === 'string') {
      this.value = val === 'true' || val === '1' || val === 'yes';
    } else {
      this.value = !!val;
    }
  }

  resetValue = () => {
    this.value = this.getDefaultBooleanValue();
  };
}

export default FilterCheckbox;
